import { render, staticRenderFns } from "./FormAndDosageModal.vue?vue&type=template&id=4ad7b120&scoped=true"
import script from "./FormAndDosageModal.vue?vue&type=script&lang=js"
export * from "./FormAndDosageModal.vue?vue&type=script&lang=js"
import style0 from "./FormAndDosageModal.vue?vue&type=style&index=0&id=4ad7b120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad7b120",
  null
  
)

export default component.exports